<template>
    
    <v-container v-if="superUser || permission" fluid class="b-container">
        <b-announcement
            v-if="announcement.active"
            :color="announcement.color"
            :text-color="announcement.textColor"
        >
        <div v-for="(txt, i) in announcement.texts" :key="i">
            <router-link
            v-if="txt.href"
                :to="txt.href"
                class="b-signin-link"
                ><span style="color:black; text-decoration: underline;">{{
                     txt.value[lang]
                }}</span></router-link>  
                <span v-else style="white-space: pre;">{{ txt.value[lang] }} </span></div>
         <span style="font-weight: 500;" v-if="announcement.description">{{ `: ${announcement.description[lang]}` }}</span>
        </b-announcement>
        <v-sheet class="pa-3" :class="{ 'mx-3': tabsWithMargin }">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
                show-arrows
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize text-left text-md-center
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3" style="background: transparent;">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
 
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/general/settings/billingDashboard";

export default {
    name: "BillingDashboard",

    mixins: [translations],

    data() {
        return {
            tab: this.$route.path,
     
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "panelType"
        ]),
        
        ...mapState("general/settings/billingDashboard/current", [
            "subscription",
            "subscriptionPlan",
            "currentBilling"
        ]),
        
        ...mapState("general/settings/billingDashboard/paymentMethods", [
            "selectedMethod",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return this.superUser || (this.$store.state.permissions.general_settings
                ? this.$store.state.permissions.general_settings.billing_dashboard.read
                : null);
        },


        tabs() {
            let arr = [];

            
            arr.push({
                    name: { el: "Τρέχων", en: "Current", it: "Attuale" },
                    to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/current`,
                });

            arr.push({
                name: { el: "Μέθοδοι πληρωμής", en: "Payment Methods", it: "Modalità di pagamento" },
                to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/payment-methods`,
            });

            arr.push({
                name: { el: "Ιστορικό πληρωμών", en: "Payment History", it: "Storico dei pagamenti" },
                to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/payment-history`,
            });

            arr.push({
                name: { el: "Ειδοποιήσεις Email", en: "Email Notifications", it: "Notifiche via e-mail" },
                to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/email-notifications`,
            });
            
            return arr;
        },

        
        tabsWithMargin() {
            return (
                this.$route.path === `/${this.lang}/${this.panelType}/settings/profile`
            );
        },

        announcement() {
            let announcement = {
                active: false,
                texts: []
            }
            if(this.subscription && this.subscription.method_chosen===false){
                announcement.active = true
                announcement.texts = [
                    {value: this.translations.choosePaymentMethodError1||{}},
                    {
                        value: this.translations.choosePaymentMethodError2||{},
                        href: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/payment-methods`
                    },
                    {value: this.translations.choosePaymentMethodError3||{}},
                ]
                announcement.textColor = 'black'
                announcement.color = 'error'
            }
            else if(this.selectedMethod && !this.selectedMethod.status.includes('ok')){
                announcement.active = true
                announcement.texts = [{value: this.translations[`methodStatus_${this.selectedMethod.status}`]||{}}]
                announcement.description = this.translations[`methodStatus_description_${this.selectedMethod.status}`]
                announcement.textColor = 'black'
                announcement.color = 'error'
            }
            
            return announcement
        }

    },

    methods: {
      
        ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),
        ...mapActions("general/settings/billingDashboard", [
          "fetchBillingDashboardData"
        ]),
    },

    watch: {
        permission: {
            // immediate: true,
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/${this.panelType}/forbidden-gateway`
                    );
                }
            },
        },
     
    },

    mounted() {
        this.fetchBillingDashboardData();
        if (this.$route.name == 'BillingDashboard') {
            this.$router.replace({ path: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/current`})
        }
    },
    

};
</script>
<style>


.relative {
    position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}

</style>
